
import ScanImg from '@/assets/scan.png'
import CHeader from '@/components/Header'
import CPosition from '@/components/Position'
import {
scanQRCode
} from '@utils/wechat'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Msg from 'vux/src/components/msg/index.vue'

export default {
name: 'Order',
components: {
Group,
Cell,
XInput,
XButton,
CHeader,
CPosition,
Msg
},

data () {
return {
scan_type: 1,
ASNArr: [],
ASN: '',
CAR_NO: '',
ScanImg: ScanImg,
msg: null,
enabled: true 
}
},
computed: {
position () {
return this.$store.getters.getPosition
}
},
created () {
this.TYPE = this.$route.query.TYPE || 0
this.$store.dispatch('baiduPosition')
this.loadData()
if (this.$route.query.ASN) {
let str=this.$route.query.ASN
if(str.indexOf(',')!='-1'){
str=str.split(',')[1]
}
this.addAsn(str)
}
},
methods: {
openScan () {
let _this = this
scanQRCode(_this.scan_type).then(res => {
console.log('scan result', res)
if(res.indexOf(',')!='-1'){
res=res.split(',')[1]
}
if(!(/^[A-Za-z]{3}/).test(res)){
_this.$toast.warn('您扫码结果为'+res+' 扫码识别不成功，请重新扫码')
return;
};



this.addAsn(res)



})
},
addAsn (ASN) {
if(ASN.indexOf(',')!='-1'){
ASN=ASN.split(',')[1]
}
if (ASN && this.ASNArr.indexOf(ASN) === -1) this.ASNArr.push(ASN)
this.ASN = ''
},
delAsn (ASN) {
if(ASN.indexOf(',')!='-1'){
ASN=ASN.split(',')[1]
}
console.log(this.ASNArr.indexOf(ASN))
this.ASNArr.splice(this.ASNArr.indexOf(ASN), 1)
},
loadData () {
let _this = this
_this.$vux.loading.show()
let url = 'Truck.ashx?action=Get_Car_By_Driver'
return this.$post(url, {}).then(
response => {
let res = JSON.parse(response)
_this.CAR_NO = res[0].CAR_NO
}
).catch(
response => {
_this.$toast.warn(response.Msg)
}
)
},
save () {
let _this = this
_this.$vux.loading.show()
let url = 'Truck.ashx?action=TH_Regist_ASN'
this.$post(url, {
ASN: _this.ASNArr.join(','),
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr,
CAR_NO: _this.CAR_NO
}, {errorTips: false}).then(
response => {
let data = JSON.parse(response)
this.$router.push({
path: `/sctsnew/thd?ID=${data[0].ID}&WORKNO=${data[0].WORKNO}`
})












}
).catch(
response => {






this.msg = {
title: response.Msg,
icon: 'warn',
buttons: [{
type: 'default',
text: '我知道了',
onClick: () => {
this.msg = null
}
}]
}
}
)
},
resetData () {
this.msg = null
this.enabled = true
this.ASNArr = []
}
}
}



// WEBPACK FOOTER //
// ./src/pages/sctsnew/Asn.vue